// extracted by mini-css-extract-plugin
export var container = "_6w-0";
export var infoButton = "_6w-1";
export var label = "_6w-3";
export var labelExpanded = "_6w-4";
export var price = "_6w-5";
export var priceExpanded = "_6w-6";
export var title = "_6w-2";